// Menu taster poll: shared settings for the pop-up and the welcome pop-up.
export const POLL_KEY = "menu-taster-2026-10";

// Master switch. While false the poll pop-up, the home page banner and every request to the poll server
// are off, so the site can go live without the poll database table and PHP files.
// Set to true only after those are deployed (see the poll deploy steps).
export const POLL_ENABLED = false;

// Voting closes at 23:59 on Saturday 24 October 2026 (UK time, still on summer time); the server enforces this too.
export const POLL_CLOSES_AT = new Date("2026-10-24T23:59:59+01:00").getTime();

export const POLL_OPTIONS = [
  { id: 1, name: "Gidi Fried Chicken" },
  { id: 2, name: "Dundu & Plantain with Sauce" },
  { id: 3, name: "Gidi Chicken Wrap" },
  { id: 4, name: "Suya Burger" },
];

// Which customer accounts have voted on this browser (so another account on the same device can still vote)
const VOTED_IDS_KEY = `poll_voted_ids_${POLL_KEY}`;

const safeGet = (key) => {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
};

const safeSet = (key, value) => {
  try {
    localStorage.setItem(key, value);
  } catch {
    // storage blocked: the poll just shows again next visit
  }
};

export const POLL_OPEN_EVENT = "poll-open";
export const POLL_VOTED_EVENT = "poll-voted";

const getVotedIds = () => {
  try {
    const ids = JSON.parse(safeGet(VOTED_IDS_KEY) || "[]");
    return Array.isArray(ids) ? ids.map(Number) : [];
  } catch {
    return [];
  }
};

// Remember that this customer has voted (the server is the real record)
export const markPollVoted = (customerId) => {
  const id = Number(customerId);
  if (id) {
    const ids = getVotedIds();
    if (!ids.includes(id)) safeSet(VOTED_IDS_KEY, JSON.stringify([...ids, id]));
  }
  window.dispatchEvent(new Event(POLL_VOTED_EVENT));
};

// Has this customer account voted? Logged-out visitors count as not voted: they have to log in to vote anyway.
export const hasVotedHere = (customerId) => Boolean(customerId) && getVotedIds().includes(Number(customerId));

// Lets the link on the home page open the poll pop-up
export const openPoll = () => window.dispatchEvent(new Event(POLL_OPEN_EVENT));

export const isPollOpenByDate = () => POLL_ENABLED && Date.now() < POLL_CLOSES_AT;

// Is the poll worth showing for this customer right now? (The server has the final say on votes.)
export const isPollActiveHere = (customerId) => {
  // Testing aid, local development only: open any page with ?resetpoll=1 to forget earlier votes on this browser
  if (process.env.NODE_ENV !== "production" && new URLSearchParams(window.location.search).get("resetpoll") === "1") {
    try {
      localStorage.removeItem(VOTED_IDS_KEY);
    } catch {
      // storage blocked
    }
  }

  if (!POLL_ENABLED || Date.now() >= POLL_CLOSES_AT) return false;
  if (hasVotedHere(customerId)) return false;
  return true;
};
